import Organisation from './Organisation'
import OrganisationCustomDomain from './OrganisationCustomDomain'

Organisation.OrganisationCustomDomain = OrganisationCustomDomain

export default Organisation
